<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="loading"
    :items="items"
    :items-length="totalItems"
    class="elevation-1"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Waterfall Filters</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @input="searchTable()"
          />

          <v-spacer />

          <WaterfallFilterDeleteModal
            v-model="dialogDelete"
            :edited-item="editedItem"
            @close-modal="closeModal('dialogDelete')"
            @item-deleted="itemDeleted()"
            @click:outside="clearState()"
          />

          <WaterfallFilterFormModal
            v-model="dialogForm"
            :edited-item="editedItem"
            :adverse-actions="adverseActions"
            @close-modal="closeModal('dialogForm')"
            @item-saved="itemSaved()"
            @click:outside="clearState()"
          />

          <v-btn
            v-if="hasPermission('create system-settings::waterfall-filters')"
            dark
            class="mb-2 btn-bg-deep-blue"
            @click="dialogForm = true"
          >
            <v-icon>mdi-plus</v-icon>
            New Waterfall Filter
          </v-btn>
          <disabled-for-lack-of-role-btn
            v-else
            text="New Waterfall Filter"
            permission="create system-settings::waterfall-filters"
            :x-small="false"
            button-class="mb-2"
          />
        </v-toolbar>
      </v-card-title>
    </template>

    <template #item.send_email="{ item }">
      <span :class="item.send_email ? 'green--text' : 'red--text'">
        {{ item.send_email ? 'Yes' : 'No' }}
      </span>
    </template>

    <template #item.actions="{ item }">
      <v-icon
        v-if="hasPermission('edit system-settings::waterfall-filters')"
        :id="item"
        class="mr-10"
        @click="editItem(item)"
      >
        mdi-pencil-outline
      </v-icon>
      <disabled-for-lack-of-role-btn
        v-else
        text=""
        icon="mdi-pencil-outline"
        :text-button="true"
        permission="edit system-settings::waterfall-filters"
        :x-small="false"
        button-class="mr-10"
      />

      <v-icon
        v-if="hasPermission('delete system-settings::waterfall-filters')"
        class="red--text"
        @click="deleteItem(item)"
      >
        mdi-delete-outline
      </v-icon>
      <disabled-for-lack-of-role-btn
        v-else
        text=""
        icon="mdi-delete-outline"
        :text-button="true"
        permission="delete system-settings::waterfall-filters"
        :x-small="false"
        button-class="mr-10"
      />
    </template>
  </v-data-table-server>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';

import WaterfallFilterDeleteModal from '@/views/Settings/WaterfallFilter/WaterfallFilterDeleteModal.vue';
import WaterfallFilterFormModal from '@/views/Settings/WaterfallFilter/WaterfallFilterFormModal.vue';
import DisabledForLackOfRoleBtn from '../../DisabledForLackOfRoleBtn.vue';

export default {
  components: {
    WaterfallFilterFormModal,
    WaterfallFilterDeleteModal,
    DisabledForLackOfRoleBtn,
  },

  mixins: [
    dataTableMixin,
  ],

  data: () => ({
    headers: [
      { title: 'ID', value: 'id' },
      { title: 'Slug', value: 'filter_slug' },
      { title: 'Class', value: 'class' },
      { title: 'Method', value: 'method' },
      { title: 'Adverse Action', value: 'description' },
      { title: 'Email', value: 'send_email' },
      { title: 'Lead Provider Type', value: 'lead_provider_type' },
      {
        title: 'Actions',
        value: 'actions',
        width: 120,
        sortable: false,
      },
    ],

    dialogDelete: false,
    dialogForm: false,
    editedItem: {
      id: null,
    },
    adverseActions: [],
  }),

  created() {
    this.fetchAdverseActions();
  },

  methods: {
    closeModal(modal) {
      this[modal] = false;
      this.clearState();
    },
    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = { ...item };
      this.dialogForm = true;
    },
    itemDeleted() {
      this.items = [];
      this.updateTable();
    },
    itemSaved() {
      this.items = [];
      this.updateTable();
    },
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/waterfall-filter', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },
    clearState() {
      this.$nextTick(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      });
    },
    fetchAdverseActions() {
      this.$axios
        .get('/api/v1/adverse-action?perPage=100')
        .then((res) => {
          const { data } = res.data;

          this.adverseActions = data.map((item) => ({
            value: item.id,
            text: `${item.code} - ${item.description}`,
          }));
        });
    },
  },
};
</script>
